import React, { useEffect, useContext, useState, useRef } from 'react';
//Componentes importados desde material ui
import { Grid, ThemeProvider, CircularProgress, Backdrop, Snackbar } from '@material-ui/core';
//Componentes comunes importados
import Input from '../../commons/input/Input';
import RadioButton from '../../commons/radioButton/RadioButton';
import DireccionGenerica from '../../commons/direccionGenerica/DireccionGenerica';
import TextoEstatico from '../../commons/textoEstatico/TextoEstatico';
import { default as AlertCustom } from '../../commons/alert/Alert';
import { Alert } from '@material-ui/lab';
import Confirmacion from '../../commons/Confirmacion/Confirmacion';
//Fichero de funciones importado
import useForm from './pageAltaUsuarioFunctions';
//Estilo importado
import PageAltaUsuarioStyle from './PageAltaUsuarioStyle';
//Sobreescritura de clases de material ui
import { overInputs } from './PageAltaUsuarioStyle';
//Fichero data importado
import { objAttributes, objText, objAttDireccion, attributesValidation, attributesValidationForm, properties, propertiesPCT3 } from './pageAltaUsuarioData';
//Objetos para alimentar los campos con pruebas a la espera del endPoint
import objSexo from '../../commons/radioButton/RadioButtonData';
//Para operaciones con el CRUD
import RestProvider from 'providers/RestProvider';
import { properties as propertiesApp, compProperties as componentsProperties } from '../../../AppData';
import { useHistory } from "react-router-dom";
import { loadState, saveState } from './../../../providers/localStorage';
import { localStorageName } from './../../../providers/localStorageData';
import AppContext from 'AppContext';
import { codigoPais } from '../../../AppData';
import { useSelector } from 'react-redux';

/**
 * Variables que controlan los atributos que se insertará en la dirección genérica, además de habilitar y deshabilitar
 * los datos de la entidad representada.
 * 
 * La variable datosEntidadRepresentada con el valor false, insertará los atributos de la direccionGenerica de la entidadRepresentada
 * La variable datosInteresado con el valor true insertará los atribuos de la direccioGeneria del interesado.
 */

// FUTURO REFACTOR DE ESTA ESTRUCTURA
let datosInteresado = true;
let datosEntidadRepresentada = false;

/**
 * @function AltaUsuario función que contiene la pantalla de alta de usuario y es devuelta.
 */
export default function AltaUsuario() {

    //Referencias necesarias para el focus
    const refDNI = useRef(null);
    const refNombreInteresado = useRef(null);
    const refApellido1 = useRef(null);
    const refApellido2 = useRef(null);
    const refFechaNacimiento = useRef(null);
    const refEmail = useRef(null);
    const refTelefono = useRef(null);
    const refTelefonoMovil = useRef(null);
    const refSexo = useRef(null);
    
    const refTipoViaInteresado = useRef(null);
    const refNombreDomicilioInteresado = useRef(null);
    const refNumeroDomicilioInteresado = useRef(null);
    const refPisoDomicilioInteresado = useRef(null);
    const refProvinciaDomicilioInteresado = useRef(null);
    const refMunicipioDomicilioInteresado = useRef(null);
    const refPaisDomicilioInteresado = useRef(null);
    const refCodigoPostalDomicilioInteresado = useRef(null);
    const refMunicipioInteresado = useRef(null);
    const refPaisInteresado = useRef(null);

    //Entidad representada
    const refcif = useRef(null);
    const refRazonSocial = useRef(null);
    const refEmailEntidad = useRef(null);
    const refTlfEntidad = useRef(null);
    const refTlfMovilEntidad = useRef(null);
    const refTipoViaEntidad = useRef(null);
    const refNombreViaEntidad = useRef(null);
    const refNumeroEntidad = useRef(null);
    const refPisoEntidad = useRef(null);
    const refProvinciaEntidad = useRef(null);
    const refMunicipioEntidad = useRef(null);
    const refCodigoPostalEntidad = useRef(null);

    let tiposVias = null;
    let interesado = null;
    let entidad = null;
    let esRepresentante;
    let refAlerta;
    let _ID = 0;
    let mostrarAlert = false;

    const [paises, setPaises] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [municipiosInteresado, setMunicipiosInteresado] = useState([]);
    const [municipiosEntidad, setMunicipiosEntidad] = useState([]);
    const [tipoVias, setTipoVias] = useState([]);
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({ msg: "", severity: "" });
    const [alerts, setAlerts] = useState([]);
    const [textoBotonSubmit, setTextoBotonSubmit] = useState(objText.botones.btnCrearCuenta);
    const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
    const [pathOrigen, setPathOrigen] = useState('/');
    const context = useContext(AppContext);
    const { crudOperation, crudOperationsType } = RestProvider();

    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const perfilSeleccionado = useSelector((state) => state.kingdomOV3.perfilSeleccionado);

    const addAlert = msg => setAlerts([...alerts, { id: _ID++, msg }]);
    const claseAlert = PageAltaUsuarioStyle();
    const sexos = objSexo;

    const urlProcedenciaProcedimiento = useSelector((state) => state.kingdomOV3.urlProcedenciaProcedimiento);
    
    //Eventos de cambio(); de estado y valor
    const { validationsOnBlur, handleChange, obtenerObjetoUsuario, gotoElement, validarCamposObligatorios,
        values, setValues, showAlert, setShowAlert, nombreDomicilioInteresadoValid,
        emailValid, dniValid, cifValid, nombreValid, apellido1Valid, fechaValid, tlfValid, tlfMovilValid, sexoValid, codigoPostalInteresadoValid, nombreProvinciaInteresadoValid, nombreMunicipioInteresadoValid, paisDomicilioInteresadoValid,
        descripcionTipoViaDomicilioInteresadoValid, numDomicilioInteresadoValid, entidadRazonSocialEntidadRepresentadaValid, tipoViaValidEntidad, nombreViaValidEntidad, pisoValidEntidad, numeroValidEntidad,
        provinciaValidEntidad, municipioValidEntidad, codigoPostalValidEntidad, numPisoInteresadoValid, emailValidEntidad, tlfValidEntidad, tlfMovilEntidad,
        addValuesObjetc, removeValuesObject, obtenerObjetoInteresadoPCT3, setDataFrom, loadInfoCloud, mailDPD } = useForm();

    // Carga de datos inicial
    useEffect(() => {
        if (infoUsuario === undefined || infoUsuario === '') {
            history.push("/");

        } else {
            recuperarDatos();
        }
        context.updateTitlePage(objText.titulos.altaUsuario);
        crearPathDeVuelta();
        loadInfoCloud();
        return () => window.removeEventListener('resize', updateFormat);
    }, []);

    // Asignación automática de provincia, municipio y CP para paises extranjeros
    useEffect(() => {

        // Si el código de pais no corresponde con "ESPAÑA"
        if ((values.paisDomicilioInteresado !== null) && values.paisDomicilioInteresado.codigo !== codigoPais.SPAIN) {
            
            // Función aux. para localizar la provincia "EXTRANJERO"
            function encontrarProvinciaExtranjero(arr) {
                for (const objeto of arr) {
                    if (objeto.descripcionCorta === "EXTRANJERO") {
                    return objeto;
                    }
                }
            }

            const extranjero = encontrarProvinciaExtranjero(provincias)
            
            // Obtenemos el municipio "EXTRANJERO"
            crudOperation(crudOperationsType.CUSTOM, propertiesPCT3.resource.municipios, { url: propertiesPCT3.url.provincia.concat(extranjero.codigo) + propertiesPCT3.pageable.municipios, method: 'get' }).then(response => {
                
                // Adaptamos del objeto recibido con el objeto de la OV3
                response.data[0].descripcionCorta = response.data[0].descripcion
                delete response.data[0].descripcion

                // Reescribimos los valores del formulario
                setValues({
                    ...values,
                    ['provinciaDomicilioInteresado']: extranjero,
                    ['municipioDomicilioInteresado']: response.data[0],
                    ['codigoPostalDomicilioInteresado']: "00000",
                });

            }).catch(function (error) {
                handleSetMessage("Ha ocurrido un error al intentar recuperar los datos de municipios.", 'error');
            });
        }
    }, [values.paisDomicilioInteresado])

    useEffect(() => {
        if (!values.telefonoMovilInteresado){
            values.telefonoMovilInteresado = "+";
        }
    }, [values.telefonoMovilInteresado]);

    
    //Comprueba si es una entidad representada si el cif del contexto no esta a null
    const checkEsRepresentante = () => {
        esRepresentante = (infoUsuario.entidadCif !== null);
    }

    /**Recupera los datos necesarios para la consulta de interesado */
    const recuperarDatos = async () => {
        setIsLoading(true);

        try {
            //infoUsuario son los datos que recibimos despues de hacerel login (dni, nombre, apellidos...)
            cargarDatosClaveCertificado();
            await getPaisesPCT3();
            await getProvinciasPCT3();
            await getTipoViasPCT3();

            //Si el usuario viene redirigido de la pagina SeleccionConvocatoria significa que el usuario ni está dado de alta en trewa
            var redirect = loadState(localStorageName.redirect, false);
            if (typeof redirect === 'undefined' || redirect !== 'altaUsuario') {
                await getInteresadoEntidad(infoUsuario);
            }
        } catch (error) {
            if (error.response.status != 404)
                handleSetMessage("Ha ocurrido un error al intentar recuperar los datos.", 'error');
        } finally {
            setIsLoading(false);
        }
    };

    //LLAMADAS A ENDPOINTS

    /**
     * @function getInteresadoEntidad Función que comprueba si el interesado/entidad logad@ está dada de alta en la PCT2 o en la PCT3.
     * En caso de que lo esté carga sus datos de cotnacto.
     * @param {*} infoUsuario Objeto recibido con la información del usuario.
     */
    const getInteresadoEntidad = async (infoUsuario) => {

        //Paso 1. Se realiza una consulta en la PCT3 para comprobar si el usuario existe
        // let interesadoPCT3 = 
        await getInteresadoPorDefectoPCT3(infoUsuario);

        //Paso 2. Si el usuario no existe en la PCT3, se realiza una consulta en la PCT2 para comprobar si existe
        // interesadoPCT3 === null && await getInteresadoPorDefectoPCT2(infoUsuario);
        
        //Paso 3. Si existe en alguno de los sistemas, se procede a la carga de los datos del usuario existente
        if (interesado !== null) {
            await cargarDatosUsuarioExistente();
            setTextoBotonSubmit(objText.botones.btnModificarCuenta); //Cambia el texto del botón submit
        }
    }

    //Almacenar datos usuario en BD
    const guardarValues = async () => {
        setIsLoading(true);
        await guardarActualizarPCT3();
        guardarActualizarPCT2();
        setIsLoading(false);
    }

    const obtenerDatosSaltoBandeja = () => {     

        return {
            tipoAutenticacion: infoUsuario.tipoAutenticacion,
            nifUsuario: infoUsuario.interesadoNif,
            nombre: infoUsuario.interesadoNombre,
            apellido1: infoUsuario.interesadoApellido1,
            apellido2: infoUsuario.interesadoApellido2,
            idProcedimientoActivo: procedimientoActual.id,
            idConvocatoriaActiva: convocatoriaSeleccionada.id,
            idOrdenActiva: convocatoriaSeleccionada.idOrden,
            idPerfilActivo: perfilSeleccionado.id,
            urlSalto: procedimientoActual.url,
            datosCertificado: infoUsuario.datosCertificado,
        }
    }

    // METODOS

    const cargarDatosClaveCertificado = () => {
        values.nifInteresado = infoUsuario.interesadoNif;
        values.nombreInteresado = infoUsuario.interesadoNombre;
        values.apellido1Interesado = infoUsuario.interesadoApellido1;
        values.apellido2Interesado = infoUsuario.interesadoApellido2;

        if (esRepresentante) {
            values.cifEntidadRepresentada = infoUsuario.entidadCif;
            values.entidadRazonSocialEntidadRepresentada = infoUsuario.entidadNombre;
        }
    }

    /**Carga los campos si el usuario ya existía */
    const cargarDatosUsuarioExistente = async () => {

        let datosInteresado = interesado.interesado;
        let datosContactoInteresado = interesado.datosContacto;
        let sexoObtenido = {
            codigo: datosInteresado.sexo === "Hombre" ? "M": "F",
            descripcion: datosInteresado.sexo
        };

        // A partir del municipio se obtiene la provincia y el país
        let municipioObtenidoInteresado = await getMunicipioPorIdPCT3(datosContactoInteresado.idMunicipio);
        let paisObtenidoInteresado = await getPaisPorIdPCT3(datosContactoInteresado.idPais);

        /*El interesado solo tiene el codigo del sexo, hay que filtrar 
        los sexos por el codigo para obtener la descripcion*/
        let sexoInteresado = sexos.filter(value => value.codigo === sexoObtenido.codigo)[0];

        values.fechaNacimientoInteresado = datosInteresado.fechaNacimiento === undefined ? '' : datosInteresado.fechaNacimiento.substr(0, properties.DATE_LENGTH);
        values.sexoInteresado = JSON.stringify(sexoInteresado);
        values.telefonoInteresado = datosContactoInteresado.telefono === undefined ? '' : datosContactoInteresado.telefono;
        values.telefonoMovilInteresado = datosContactoInteresado.telefonoMovil === undefined ? '' : datosContactoInteresado.telefonoMovil;
        values.emailInteresado = datosContactoInteresado.email === undefined ? '' : datosContactoInteresado.email;
        values.paisDomicilioInteresado = paisObtenidoInteresado === undefined ? '' : paisObtenidoInteresado;
        values.provinciaDomicilioInteresado = municipioObtenidoInteresado.provincia;
        values.municipioDomicilioInteresado = municipioObtenidoInteresado;
        values.tipoViaDomicilioInteresado = tiposVias.filter(value => value.codigo === datosContactoInteresado.tipoVia.codigo)[0];        
        values.codigoPostalDomicilioInteresado = datosContactoInteresado.postal;
        values.nombreDomicilioInteresado = datosContactoInteresado.nombreVia;
        values.numeroDomicilioInteresado = datosContactoInteresado.numero === undefined ? '' : datosContactoInteresado.numero;
        values.pisoDomicilioInteresado = datosContactoInteresado.piso === undefined ? '' : datosContactoInteresado.piso;
        values.escaleraDomicilioInteresado = datosContactoInteresado.escalera === undefined ? '' : datosContactoInteresado.escalera;
        values.puertaDomicilioInteresado = datosContactoInteresado.puerta === undefined ? '' : datosContactoInteresado.puerta;
        values.letraDomicilioInteresado = datosContactoInteresado.letra === undefined ? '' : datosContactoInteresado.letra;    

        //Valores que no se usan en la pantalla pero hay que mantenerlos
        values.idInteresado = datosInteresado.id;
        values.idDatoscontactoInteresado = datosContactoInteresado.id;

        // Entidad
        if (entidad !== null) {
            let datosEntidad = entidad.interesado;
            let datosContactoEntidad = entidad.datosContacto;
            let municipioObtenidoEntidad = await getMunicipioPorIdPCT3(datosContactoEntidad.idMunicipio);
            let paisObtenidoEntidad = await getPaisPorIdPCT3(datosContactoEntidad.idPais);
            
            // *Se establece una condición para insertar un String vacío en los campos NO obligatorios en caso de que en el objeto (interesado) no se reciban los valores
            values.idEntidad = datosEntidad.id;
            values.cifEntidadRepresentada = datosEntidad.identificador;
            values.entidadRazonSocialEntidadRepresentada = datosEntidad.nombre;
            values.idDatoscontactoEntidad = datosContactoEntidad.id;
            values.tipoViaDomicilioEntidadRepresentada = tiposVias.filter(value => value.codigo === datosContactoEntidad.tipoVia.codigo)[0]; 
            values.nombreDomicilioEntidadRepresentada = datosContactoEntidad.nombreVia;
            values.numeroDomicilioEntidadRepresentada = datosContactoEntidad.numero === undefined ? '' : datosContactoEntidad.numero;
            values.letraDomicilioEntidadRepresentada = datosContactoEntidad.letra === undefined ? '' : datosContactoEntidad.letra;
            values.escaleraDomicilioEntidadRepresentada = datosContactoEntidad.escalera === undefined ? '' : datosContactoEntidad.escalera;
            values.pisoDomicilioEntidadRepresentada = datosContactoEntidad.piso === undefined ? '' : datosContactoEntidad.piso;
            values.puertaDomicilioEntidadRepresentada = datosContactoEntidad.puerta === undefined ? '' : datosContactoEntidad.puerta;
            values.codigoPostalDomicilioEntidadRepresentada = datosContactoEntidad.postal;
            values.telefonoEntidadRepresentada = datosContactoEntidad.telefono === undefined ? '' : datosContactoEntidad.telefono;
            values.telefonoMovilEntidadRepresentada = datosContactoEntidad.telefonoMovil === undefined ? '' : datosContactoEntidad.telefonoMovil;
            values.emailEntidadRepresentada = datosContactoEntidad.email === undefined ? '' : datosContactoEntidad.email;
            values.paisDomicilioEntidadRepresentada = paisObtenidoEntidad === undefined ? '' : paisObtenidoEntidad;
            values.provinciaDomicilioEntidadRepresentada = municipioObtenidoEntidad.provincia;
            values.municipioDomicilioEntidadRepresentada = municipioObtenidoEntidad;
        }
    }

    /**Gestiona la dependencia que tiene el desplegable de municipios del de provincias en el apartado de interesado */
    const handleProvincia = (event, newValue, idObjeto) => {
        let ref, municipio;
        if (idObjeto === 'provinciaDomicilioInteresado') {
            ref = refMunicipioInteresado;
            municipio = values.municipioDomicilioInteresado;
        } else {
            ref = refMunicipioEntidad;
            municipio = values.municipioDomicilioEntidadRepresentada;
        }

        ref.current.getElementsByTagName('button')[0].click();
        municipio = null;

        handleChange(event, newValue, idObjeto);

        if (newValue !== null) {
            let codProvincia = newValue.codigo;
            getMunicipiosPCT3(codProvincia, idObjeto === 'provinciaDomicilioInteresado' ? true : false);
        } else {
            idObjeto === 'provinciaDomicilioInteresado' ? setMunicipiosInteresado([]) : setMunicipiosEntidad([]);
        }
    }

    //**Gestiona los mensajes de por pantalla para errores, info, etc */
    const handleSetMessage = (msg, severity) => {
        setMessage({ msg, severity });
        addAlert(message);
    }

    //Metodo que metera en un Array solo las referencias de los campos que hayan saltado las validaciones
    const creaMensajeAlert = () => {
        let refAlert = [];
        !dniValid &&
            refAlert.push(refDNI);
        !nombreValid &&
            refAlert.push(refNombreInteresado);
        !apellido1Valid &&
            refAlert.push(refApellido1);
        !fechaValid &&
            refAlert.push(refFechaNacimiento);
        !emailValid &&
            refAlert.push(refEmail);
        !tlfValid &&
            refAlert.push(refTelefono);
        !tlfMovilValid &&
            refAlert.push(refTelefonoMovil);
        !sexoValid &&
            refAlert.push(refSexo);

        !descripcionTipoViaDomicilioInteresadoValid &&
            refAlert.push(refTipoViaInteresado);
        !nombreDomicilioInteresadoValid &&
            refAlert.push(refNombreDomicilioInteresado)
        !numDomicilioInteresadoValid &&
            refAlert.push(refNumeroDomicilioInteresado);
        !numPisoInteresadoValid &&
            refAlert.push(refPisoDomicilioInteresado);
        !nombreProvinciaInteresadoValid &&
            refAlert.push(refProvinciaDomicilioInteresado);
        !nombreMunicipioInteresadoValid &&
            refAlert.push(refMunicipioDomicilioInteresado);
        !paisDomicilioInteresadoValid &&
            refAlert.push(refPaisDomicilioInteresado);
        !codigoPostalInteresadoValid &&
            refAlert.push(refCodigoPostalDomicilioInteresado);

        //Entidad representante
        !cifValid &&
            refAlert.push(refcif);
        !entidadRazonSocialEntidadRepresentadaValid &&
            refAlert.push(refRazonSocial);
        !emailValidEntidad &&
            refAlert.push(refEmailEntidad);
        !tlfValidEntidad &&
            refAlert.push(refTlfEntidad);
        !tlfMovilEntidad &&
            refAlert.push(refTlfMovilEntidad);
        !tipoViaValidEntidad &&
            refAlert.push(refTipoViaEntidad);
        !nombreViaValidEntidad &&
            refAlert.push(refNombreViaEntidad);
        !numeroValidEntidad &&
            refAlert.push(refNumeroEntidad);
        !pisoValidEntidad &&
            refAlert.push(refPisoEntidad);
        !provinciaValidEntidad &&
            refAlert.push(refProvinciaEntidad);
        !municipioValidEntidad &&
            refAlert.push(refMunicipioEntidad);
        !codigoPostalValidEntidad &&
            refAlert.push(refCodigoPostalEntidad);

        if (showAlert) {
            if (refAlert.length) {
                mostrarAlert = true;
            }
            else {
                mostrarAlert = false;
                setShowAlert(false);
            }
        }

        return refAlert;
    }

    /**Método que capta el tamaño de la ventana y actualiza actualiza
    ***el hook que controla cuando se da el salto a versión movil*/
    const updateFormat = () => {

        if (window.matchMedia(`(max-width: ${propertiesApp.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    };

    const history = useHistory();

    /**
     * Validaciones
     * En esta estructura de control se verifica si los campos obligatorios sometidos a la validación son válidos o no.
     * La estructura de control valida todos los campos si alguno de ellos no es válido detiene el envío del formulario.
     */
    const handleSubmit = (e) => {
        e.preventDefault();

        if (validarCamposObligatorios()) {
            guardarValues();
        } else {
            setShowAlert(true);
            gotoElement();
        }
    }

    const altaUsuarioMostrarConfirmacion = accion => {
        setMostrarConfirmacion(accion);
    }

    const mostrarConfirmacionSalida = () => {
        setMostrarConfirmacion(true);
    }

    const crearPathDeVuelta = () => {
        const rutaOrigen = loadState(localStorageName.redirect, false);
        if (rutaOrigen === 'altaUsuario') {
            setPathOrigen('/SeleccionConvocatoriaPerfil' + urlProcedenciaProcedimiento);
        }
    }

    const redirigirCancelacion = () => {
        saveState(localStorageName.redirect, pathOrigen, false);
        history.push(pathOrigen);
    }

    // LLAMADAS A METODOS

    window.addEventListener('resize', updateFormat);

    refAlerta = creaMensajeAlert();

    checkEsRepresentante();

    /*************** ENDPOINTS PCT3 ***************/

    /**
     * @function getPaisesPCT3 Función que obtiene un listado de países
     */
     const getPaisesPCT3 = async () => {
        //Paso 1. Obtención del listado de países
        await crudOperation(crudOperationsType.CUSTOM, propertiesPCT3.resource.paises, {url: propertiesPCT3.pageable.paises, method: 'get' }).then(response => {
            setPaises(response.data.content);
        }).catch(function (error) {
            handleSetMessage("Ha ocurrido un error al intentar recuperar los datos de paises.", 'error');
        });
    };

    /**
     * @function getProvinciasPCT3 Obteiene un listado de provincias
     */
     const getProvinciasPCT3 = async () => {
        //Paso 1. Obtención del listado de provincias
        await crudOperation(crudOperationsType.CUSTOM, propertiesPCT3.resource.provincias, { url: propertiesPCT3.pageable.provincias, method: 'get' }).then(response => {
            let listadoProvincias = response.data.content;
            //Paso 2. Adaptación del objeto recibido con el objeto de la OV3
            for (const provincia of listadoProvincias) {
                addValuesObjetc(provincia, [{descripcionCorta: provincia['nombre']}]);    
            }
            removeValuesObject(listadoProvincias, ['nombre']);
            setProvincias(listadoProvincias);
        }).catch(function (error) {
            handleSetMessage("Ha ocurrido un error al intentar recuperar los datos de provincias.", 'error');
        });
    }

    /**
     * @function getMunicipiosPCT3 Obtiene un listado de municipios
     * @param {*} idProvincia 
     */
     const getMunicipiosPCT3 = async (idProvincia, esInteresado) => {
        //Paso 1. Obtención del listado de municipios
        await crudOperation(crudOperationsType.CUSTOM, propertiesPCT3.resource.municipios, { url: propertiesPCT3.url.provincia.concat(idProvincia) + propertiesPCT3.pageable.municipios, method: 'get' }).then(response => {
            let listadoMunicipios = response.data;
            //Paso 2. Adaptación del objeto recibido con el objeto de la OV3
            for (const municipio of listadoMunicipios) {
                addValuesObjetc(municipio, [{descripcionCorta: municipio['descripcion']}]);
            }
            removeValuesObject(listadoMunicipios, ['descripcion']);
            esInteresado ? setMunicipiosInteresado(listadoMunicipios) : setMunicipiosEntidad(listadoMunicipios);
        }).catch(function (error) {
            handleSetMessage("Ha ocurrido un error al intentar recuperar los datos de municipios.", 'error');
        });
    }

    /**
     * @function getMunicipioPorIdPCT3 Obtiene un municipio a través de su id (también contiene la provincia y el país al que pertenece el municipio)
     * @param {*} id 
     * @returns 
     */
    const getMunicipioPorIdPCT3 = async (id) => {
        let municipioObtenido = null;
        //Paso 1. Obtención del municipio
        await crudOperation(crudOperationsType.CUSTOM, propertiesPCT3.resource.municipios, {url: `/${id}`, method: 'get' }).then(response => {
            municipioObtenido = response.data;

            //Paso 2. Se modifica el objeto que se devuelve para que conicida con el objeto actual
            //Municipio
            addValuesObjetc(municipioObtenido, [{descripcionCorta: municipioObtenido['descripcion']}]);
            removeValuesObject(municipioObtenido, ['descripcion']);
            //Provincia
            addValuesObjetc(municipioObtenido.provincia, [{descripcionCorta: municipioObtenido.provincia['nombre']}]);
            removeValuesObject(municipioObtenido.provincia, ['nombre']);
        }).catch(function (error) {
            handleSetMessage("Ha ocurrido un error al intentar recuperar los datos de municipios.", 'error');
        });
        return municipioObtenido;
    }

    const getPaisPorIdPCT3 = async (id) => {
        let paisObtenido = null;
        await crudOperation(crudOperationsType.CUSTOM, propertiesPCT3.resource.paises, {url: `/${id}`, method: 'get' }).then(response => {
            paisObtenido = response.data;
        }).catch(function (error) {
            handleSetMessage("Ha ocurrido un error al intentar recuperar el país.", 'error');
        });
        return paisObtenido;
    }

    /**
     * @function getTipoViasPCT3 Obtiene un listado de tipo de vías
     */
    const getTipoViasPCT3 = async () => {
        await crudOperation(crudOperationsType.CUSTOM, propertiesPCT3.resource.tipoVia, { url: propertiesPCT3.pageable.tipoVia, method: 'get' }).then(response => {
            tiposVias = response.data.content;
            setTipoVias(tiposVias);
        }).catch(function (error) {
            handleSetMessage("Ha ocurrido un error al intentar recuperar los datos de tipos de vías.", 'error');
        });
    }

    /**
     * @function getInteresadoPorDefectoPCT3 Obtiene los datos por defecto de un interesado
     * @param identificador Identificador de la persona física
     * @param identificadorEntidad Identificador de la entidad representada
     * @param interesado Devuelve el objeto interesado con todos sus valores
     */
    const getInteresadoPorDefectoPCT3 = async (infoUsuario) => {
        let datosPCT3 = null;
        //Paso 1. Se comprueba si se ha recibido la información del usuario
        if (infoUsuario !== undefined || infoUsuario !== null || infoUsuario !== '') {
            
            let interesadoBuscado = {
                identificador: infoUsuario.interesadoNif,
                identificadorEntidad: infoUsuario.entidadCif
            };

            //Paso 2. Obtención de los datos por defecto del interesado          
            await crudOperation(crudOperationsType.CUSTOM, propertiesPCT3.resource.interesdado, { url: propertiesPCT3.url.interesadoDatosContactoPorDefecto, method: 'post', data: interesadoBuscado }).then(response => {
                datosPCT3 = response.data;
                interesado = datosPCT3.interesado1 === undefined ? null : datosPCT3.interesado1;
                entidad = datosPCT3.interesado2 === undefined ? null : datosPCT3.interesado2;
                setDataFrom(propertiesPCT3.dataFrom.pct3);
            }).catch(function (error) {
                error.response.status != 404 && handleSetMessage("Ha ocurrido un error al intentar recuperar los datos del interesado.", 'error');
            });         
        }
        return datosPCT3;
    }

    /**
     * @function getInteresadoPorDefectoPCT2
     * @param {*} infoUsuario 
     * @returns Devuelve el interesado obtenido
     */
    const getInteresadoPorDefectoPCT2 = async (infoUsuario) => {
        interesado = null;

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_INTERESADO_ENTIDAD, { url: properties.URL_GET_INTERESADO_ENTIDAD, method: 'post', data: infoUsuario }).then(response => {
            interesado = response.data.interesado;
            if (esRepresentante) {
                entidad = response.data.entidad;
            }   
            setDataFrom(propertiesPCT3.dataFrom.pct2);
        }).catch(function (error) {
            error.response.status != 404 && handleSetMessage("Ha ocurrido un error al intentar recuperar los datos del interesado.", 'error');
        });

        return interesado;
    }

    /**
     * @function guardarActualizarPCT2 Función que realiza el guardado o actualizado de un interesado/entidad en la PCT2
     */
    const guardarActualizarPCT2 = async () => {   
        await obtenerIdInteresadoEntidadPCT2();     
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_INTERESADO_ENTIDAD, { url: properties.URL_POST_INTERESADO_ENTIDAD, method: 'post', data: obtenerObjetoUsuario() }).then(response => {
            let redirect = loadState(localStorageName.redirect, false);
            if (typeof redirect != 'undefined' && redirect === 'altaUsuario') {
                //Si previamente no se ha seleccionado ningún procedimiento, se evita que se produzca un error al estar el valor fromPct3 como undefined
                if (procedimientoActual.fromPct3 !== undefined) {
                    //Si es true, se da el salto a la bandeja de la OV3
                    if (procedimientoActual.fromPct3) {
                        history.push('/BandejaSolicitudes');
                    }
                    //Si no, realiza la llamada a la bandeja de la OV2
                } else {
                    crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_SALTO_BANDEJA, { url: "/", method: 'post', data: obtenerDatosSaltoBandeja() }).then(responseSalto => {
                        saveState(localStorageName.redirect, 'bandeja', false);
                        window.location.href = responseSalto.data;
                    }).catch(function (error) {
                        if (error.response.status != 404) {
                            handleSetMessage("Ha ocurrido un error al intentar saltar a la bandeja.", 'error');
                        }
                    });
                }
            } else {
                history.push('/');
            }
        }).catch(function (error) {
            handleSetMessage("Ha ocurrido un error al intentar guardar los datos del interesado.", 'error');
        });
    }

    const guardarActualizarPCT3 = async () => {
        calcularTipoIdentificador();
        await crudOperation(crudOperationsType.CUSTOM, propertiesPCT3.resource.interesdado, { url: propertiesPCT3.url.guardarActualizarInteresado, method: 'post', data: obtenerObjetoInteresadoPCT3() }).then(() => {
            let redirect = loadState(localStorageName.redirect, false);
            if (typeof redirect != 'undefined' && redirect === 'altaUsuario') {
                //Si previamente no se ha seleccionado ningún procedimiento, se evita que se produzca un error al estar el valor gestionadoEnOV3 como undefined
                if (procedimientoActual.fromPct3 !== undefined) {
                    //Si es true, se da el salto a la bandeja de la OV3
                    if (procedimientoActual.fromPct3) {
                        history.push('/BandejaSolicitudes');
                    }
                    //Si no, realiza la llamada a la bandeja de la OV2
                } else {
                    crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_SALTO_BANDEJA, { url: "/", method: 'post', data: obtenerDatosSaltoBandeja() }).then(responseSalto => {
                        saveState(localStorageName.redirect, 'bandeja', false);
                        window.location.href = responseSalto.data;
                    }).catch(function (error) {
                        if (error.response.status != 404) {
                            handleSetMessage("Ha ocurrido un error al intentar saltar a la bandeja.", 'error');
                        }
                    });
                }
            } else {
                history.push('/');
                handleSetMessage("Se ha realizado correctamente el guardado de los datos del interesado.", 'success');
            }
        }).catch(function (error) {
            handleSetMessage("Ha ocurrido un error al intentar guardar los datos del interesado.", 'error');
        });
    }

    /**
     * @function calcularTipoIdentificador Función que calcula el tipo de identificador, a partir de los datos del certificado digital con el que se autentíque el interesado
     * @returns tipoIdentificador
     */
    const calcularTipoIdentificador = () => {
        let tipoIdentificador = null;

        if (infoUsuario.entidadCif !== null) {
            tipoIdentificador = 'CIF'; //Representante legal
        } else {
            const NIE = ['X', 'Y', 'Z'];
            if (NIE.includes((infoUsuario.interesadoNif).substring(0,1))) {
                tipoIdentificador = 'NIE'; //Persona física extranjera
            } else {
                tipoIdentificador = 'NIF'; //Persona física española
            }
        }
        values.tipoIdentificacion = tipoIdentificador;
    }

    const obtenerIdInteresadoEntidadPCT2 = async () => {
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_INTERESADO_ENTIDAD, { url: properties.URL_GET_INTERESADO_ENTIDAD, method: 'post', data: infoUsuario }).then(response => {
            values.idInteresado = response.data.interesado.id;
            values.idDatoscontactoInteresado = response.data.interesado.datosContacto.id;
            if (response.data.entidad !== null) {
                values.idEntidad = response.data.entidad.id;
                values.idDatoscontactoEntidad = response.data.entidad.datosContacto.id;
            }
        }).catch(function(error){
            if (error.response.status != 404) {
                handleSetMessage("Ha ocurrido un error al intentar recuperar los datos.", 'error');
            }
        });
    }    

    
    let proteccionDatos = `En cumplimiento de lo dispuesto en el Reglamento General de Protección de Datos y la Ley Orgánica 03/2018, del 5 de diciembre, de Protección de Datos de Carácter Personal y garantía de los Derechos Digitales, la Consejería de Universidad, Investigación e Innovación, le informamos que:
    a) El Responsable del tratamiento de sus datos personales es la Secretaría General Técnica cuya dirección es C/Johannes Kepler, 1, 41092. Isla de la Cartuja. 41092 – Sevilla.
    b) Podrá contactar con el Delegado de Protección de Datos en la dirección <a target="_blank" href="mailto:${mailDPD}">${mailDPD}</a>
    c) Los datos personales que nos proporciona son necesarios para la gestión de las competencias sobre provisión de infraestructuras de Servicios TIC de la Consejería.
    d) Puede usted ejercer sus derechos de acceso, rectificación, supresión, portabilidad de sus datos, y la limitación u oposición a su tratamiento, como se explica en la información adicional.
    La información adicional detallada, así como el formulario para la reclamación y/o ejercicio de derechos se encuentra disponible en la siguiente dirección electrónica: <a href="http://www.juntadeandalucia.es/protecciondedatos"target="_blank">http://www.juntadeandalucia.es/protecciondedatos</a>.`;

    // RENDER
    return (
        <ThemeProvider theme={overInputs}>{/*Se sobreescribe las classes de material ui aplicadas a los FormHelperText*/}
            <main>
                {/*BLOQUE TITULO PAGINA */}
                <Grid {...objAttributes.grids.encabezado} className={PageAltaUsuarioStyle().classGridEncabezado} container direction='column'>

                    <h2 className={PageAltaUsuarioStyle().classEncabezadoH2} {...objAttributes.titulos.altaUsuario} id="tituloPagina">
                        {objText.titulos.altaUsuario}
                    </h2>

                    <p className={PageAltaUsuarioStyle().classParrafo} {...objAttributes.parrafo}>
                        {objText.parrafo}
                    </p>

                </Grid>

                {mostrarAlert &&
                    <AlertCustom
                        classes={claseAlert}
                        {...objAttributes.alert}
                        {...objText.alert}
                        msg={refAlerta}
                    />}

                <form className={PageAltaUsuarioStyle().classContaComponentes}>


                    {///////////////INTERESADO
                        <Grid container direction={isPhoneVersion ? 'column' : ''}
                            {...objAttributes.grids.datosPersonales} className={PageAltaUsuarioStyle().classGridDatos}>

                            {/*//////////////DATOS PERSONALES*/}
                            <section id={objText.titulos.datosPersonales}>
                                <h3 className={PageAltaUsuarioStyle().classEncabezadoH3} {...objAttributes.titulos.datosPersonales}>
                                    {objText.titulos.datosPersonales}
                                </h3>

                                <Grid container direction={isPhoneVersion ? 'column' : 'row'}>
                                    <Input ///////////////NIF / NIE*
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.nifInteresado}
                                        value={values.nifInteresado}
                                        onChange={handleChange}
                                        {...attributesValidation(dniValid, objText.helperText.nifInteresado)}
                                        inputRef={refDNI}
                                        isRequired={true}
                                    />
                                    <Input ///////////////NOMBRE*
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.nombreInteresado}
                                        value={values.nombreInteresado}
                                        onChange={handleChange}
                                        {...attributesValidation(nombreValid, objText.helperText.nombreInteresado)}
                                        inputRef={refNombreInteresado}
                                        isRequired={true}
                                    />
                                    <Input ///////////////1 APELLIDO*
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.apellido1Interesado}
                                        value={values.apellido1Interesado}
                                        onChange={handleChange}
                                        {...attributesValidation(apellido1Valid, objText.helperText.apellido1Interesado)}
                                        inputRef={refApellido1}
                                        isRequired={true}
                                    />
                                </Grid>
                                <Grid container direction={isPhoneVersion ? 'column' : 'row'}>
                                    <Input ///////////////2 APELLIDO
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.apellido2Interesado}
                                        value={values.apellido2Interesado}
                                        onChange={handleChange}
                                        inputRef={refApellido2}
                                    />
                                    <Input ///////////////FECHA DE NACIMIENTO*
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.fechaNacimientoInteresado}
                                        value={values.fechaNacimientoInteresado}
                                        onChange={handleChange}
                                        {...attributesValidation(fechaValid, objText.helperText.fechaNacimientoInteresado)}
                                        inputRef={refFechaNacimiento}
                                        onBlur={validationsOnBlur}
                                        isRequired={true}
                                    />
                                    <Input ///////////////CORREO ELECTRONICO
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.emailInteresado}
                                        value={values.emailInteresado}
                                        onChange={handleChange}
                                        {...attributesValidation(emailValid, objText.helperText.emailInteresado)}
                                        inputRef={refEmail}
                                        onBlur={validationsOnBlur}
                                        autoComplete={'email'}
                                    />
                                </Grid>
                                <Grid container direction={isPhoneVersion ? 'column' : 'row'}>
                                    <Input ///////////////TELEFONO
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.telefonoInteresado}
                                        value={values.telefonoInteresado}
                                        onChange={handleChange}
                                        {...attributesValidation(tlfValid, objText.helperText.telefonoInteresado)}
                                        inputRef={refTelefono}
                                        onBlur={validationsOnBlur}
                                        autoComplete={'tel-national'}
                                    />
                                    <Input ///////////////TELEFONO MOVIL
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.telefonoMovilInteresadoInteresado}
                                        value={values.telefonoMovilInteresado}
                                        onChange={handleChange}
                                        {...attributesValidation(tlfMovilValid, objText.helperText.telefonoMovilInteresado)}
                                        inputRef={refTelefonoMovil}
                                        onBlur={validationsOnBlur}
                                        autoComplete={'tel-national'}
                                    />
                                    <RadioButton ///////////////SEXO
                                        classes={PageAltaUsuarioStyle()}
                                        classFormLabel={PageAltaUsuarioStyle().classInputLabel}
                                        {...objAttributes.sexoInteresado}
                                        options={sexos}
                                        value={values.sexoInteresado}
                                        inputRef={refSexo}
                                        onChange={(e, newValue) => handleChange(e, newValue, objAttributes.sexoInteresado.id)}
                                        {...attributesValidationForm(sexoValid, objText.helperText.sexoInteresado)}
                                        isRequired={true}
                                    />
                                </Grid>
                            </section>
                            <hr className={PageAltaUsuarioStyle().classLine} />
                            <section id={objText.titulos.direccionInteresado}>
                                <DireccionGenerica ///////////////DIRECCION INTERESADO
                                    isPhoneVersion={isPhoneVersion}
                                    titulo={datosInteresado}
                                    ///////////////descripcionTipoViaDomicilio
                                    attributesTipoVia={{ ...objAttDireccion(datosInteresado).descripcionTipoViaDomicilio, ...attributesValidation(descripcionTipoViaDomicilioInteresadoValid, objText.helperText.descripcionTipoViaDomicilioInteresado) }}
                                    tipoViaOptions={tipoVias}
                                    tipoViaGetOptionsLabel={(option) => option.descripcion}
                                    tipoViaOnChange={(e, newValue) => handleChange(e, newValue, objAttDireccion(datosInteresado).descripcionTipoViaDomicilio.id)}
                                    tipoViaValue={values.tipoViaDomicilioInteresado}
                                    refDescripcionTipoViaDomicilio={refTipoViaInteresado}
                                    ///////////////nombreDomicilio
                                    attributesNombreVia={{ ...objAttDireccion(datosInteresado).nombreDomicilio, ...attributesValidation(nombreDomicilioInteresadoValid, objText.helperText.nombreDomicilioInteresado) }}
                                    nombreViaValue={values.nombreDomicilioInteresado}
                                    nombreViaOnChange={handleChange}
                                    refNombreDomicilio={refNombreDomicilioInteresado}
                                    nombreDomicilioInteresadoOnBlur={validationsOnBlur}
                                    ///////////////numeroDomicilio
                                    attributesNumero={{ ...objAttDireccion(datosInteresado).numeroDomicilio, ...attributesValidation(numDomicilioInteresadoValid, objText.helperText.numeroDomicilioInteresado) }}
                                    numeroValue={values.numeroDomicilioInteresado}
                                    numeroOnChange={handleChange}
                                    refNumeroDomicilio={refNumeroDomicilioInteresado}
                                    numeroDomicilioInteresadoOnBlur={validationsOnBlur}
                                    ///////////////pisoDomicilio
                                    attributesPiso={{ ...objAttDireccion(datosInteresado).pisoDomicilio, ...attributesValidation(numPisoInteresadoValid, objText.helperText.pisoDomicilioInteresado) }}
                                    pisoValue={values.pisoDomicilioInteresado}
                                    pisoOnChange={handleChange}
                                    refPisoDomicilio={refPisoDomicilioInteresado}
                                    numeroPisoInteresadoOnBlur={validationsOnBlur}
                                    ///////////////puertaDomicilio
                                    attributesPuerta={{ ...objAttDireccion(datosInteresado).puertaDomicilio }}
                                    puertaValue={values.puertaDomicilioInteresado}
                                    puertaOnChange={handleChange}
                                    ///////////////letraDomicilio
                                    attributesLetra={{ ...objAttDireccion(datosInteresado).letraDomicilio }}
                                    letraValue={values.letraDomicilioInteresado}
                                    letraOnChange={handleChange}
                                    ///////////////escaleraDomicilio
                                    attributesEscalera={{ ...objAttDireccion(datosInteresado).escaleraDomicilio }}
                                    escaleraValue={values.escaleraDomicilioInteresado}
                                    escaleraOnChange={handleChange}
                                    ///////////////nombreProvinciaDomicilio
                                    attributesProvincias={{ ...objAttDireccion(datosInteresado).nombreProvinciaDomicilio, ...attributesValidation(nombreProvinciaInteresadoValid, objText.helperText.nombreProvinciaDomicilioInteresado) }}
                                    provinciasOptions={provincias}
                                    provinciasGetOptionsLabel={(option) => option.descripcionCorta}
                                    provinciasOnChange={(e, newValue) => handleProvincia(e, newValue, objAttDireccion(datosInteresado).nombreProvinciaDomicilio.id)}
                                    provinciasValue={values.provinciaDomicilioInteresado}
                                    refProvinciaDomicilio={refProvinciaDomicilioInteresado}
                                    ///////////////nombreMunicipioDomicilio
                                    attributesMunicipios={{ ...objAttDireccion(datosInteresado).nombreMunicipioDomicilio, ...attributesValidation(nombreMunicipioInteresadoValid, objText.helperText.nombreMunicipioDomicilioInteresado) }}
                                    municipiosOptions={municipiosInteresado}
                                    municipiosGetOptionsLabel={(option) => option.descripcionCorta}
                                    municipiosOnChange={(e, newValue) => handleChange(e, newValue, objAttDireccion(datosInteresado).nombreMunicipioDomicilio.id)}
                                    municipiosValue={values.municipioDomicilioInteresado}
                                    refSelect={refMunicipioInteresado}
                                    refMunicipio={refMunicipioDomicilioInteresado}
                                    ///////////////codigoPostalDomicilio
                                    attributesCodigoPostal={{ ...objAttDireccion(datosInteresado).codigoPostalDomicilio, ...attributesValidation(codigoPostalInteresadoValid, objText.helperText.codigoPostalDomicilioInteresado) }}
                                    codigoPostalValue={values.codigoPostalDomicilioInteresado}
                                    codigoPostalOnChange={handleChange}
                                    refCodigoPostal={refCodigoPostalDomicilioInteresado}
                                    codigoPostalOnBlur={validationsOnBlur}
                                    ///////////////nombrePaisDomicilio
                                    attributesPais={{ ...objAttDireccion(datosInteresado).nombrePaisDomicilio, ...attributesValidation(paisDomicilioInteresadoValid, objText.helperText.nombrePaisDomicilioInteresado) }}
                                    paisesOptions={paises}
                                    paisesGetOptionLabel={(option) => option.descripcionCorta}
                                    paisesOnChange={(e, newValue) => handleChange(e, newValue, objAttDireccion(datosInteresado).nombrePaisDomicilio.id)}
                                    paisesValue={values.paisDomicilioInteresado}
                                    refPais={refPaisDomicilioInteresado}
                                />
                            </section>
                            {esRepresentante &&
                                <hr className={PageAltaUsuarioStyle().classLine} />
                            }
                        </Grid>
                    }
                    {///////////////ENTIDAD REPRESENTADA
                        esRepresentante &&
                        <Grid container
                            {...objAttributes.grids.datosPersonales} className={PageAltaUsuarioStyle().classGridDatos}>
                            <section id={objText.titulos.datosEntidadRepresentada}>
                                <Grid container direction={isPhoneVersion ? 'column' : 'row'}>
                                    <h3
                                        className={PageAltaUsuarioStyle().classEncabezadoH3}
                                        {...objAttributes.titulos.datosEntidadRepresentada}
                                    >
                                        {objText.titulos.datosEntidadRepresentada}
                                    </h3>
                                    <Input ///////////////ENTIDAD O RAZON SOCIAL
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.entidadRazonSocialEntidadRepresentada}
                                        value={values.entidadRazonSocialEntidadRepresentada}
                                        onChange={handleChange}
                                        {...attributesValidation(entidadRazonSocialEntidadRepresentadaValid, objText.helperText.entidadRazonSocialEntidadRepresentada)}
                                        inputRef={refRazonSocial}
                                        isRequired={true}
                                    />
                                    <Input ///////////////CIF
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.cifEntidadRepresentada}
                                        value={values.cifEntidadRepresentada}
                                        onChange={handleChange}
                                        {...attributesValidation(cifValid, objText.helperText.cifEntidadRepresentada)}
                                        inputRef={refcif}
                                        isRequired={true}
                                    />
                                    <Input ///////////////CORREO ELECTRONICO
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.emailEntidad}
                                        value={values.emailEntidadRepresentada}
                                        onChange={handleChange}
                                        {...attributesValidation(emailValidEntidad, objText.helperText.emailInteresado)}
                                        inputRef={refEmailEntidad}
                                        onBlur={validationsOnBlur}
                                        autoComplete={'email'}
                                    />
                                </Grid>
                                <Grid container direction={isPhoneVersion ? 'column' : 'row'}>
                                    <Input ///////////////TELEFONO
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.telefonoEntidad}
                                        value={values.telefonoEntidadRepresentada}
                                        onChange={handleChange}
                                        {...attributesValidation(tlfValidEntidad, objText.helperText.telefonoInteresado)}
                                        inputRef={refTlfEntidad}
                                        onBlur={validationsOnBlur}
                                        autoComplete={'tel-national'}
                                    />
                                    <Input ///////////////TELEFONO MOVIL
                                        classes={PageAltaUsuarioStyle()}
                                        {...objAttributes.inputs.telefonoMovilEntidadInteresado}
                                        value={values.telefonoMovilEntidadRepresentada}
                                        onChange={handleChange}
                                        {...attributesValidation(tlfMovilEntidad, objText.helperText.telefonoInteresado)}
                                        inputRef={refTlfMovilEntidad}
                                        onBlur={validationsOnBlur}
                                        autoComplete={'tel-national'}
                                    />
                                </Grid>
                            </section>
                            <hr className={PageAltaUsuarioStyle().classLine} />
                            <section id={objText.titulos.direccionEntidadRepresentada}>
                                <DireccionGenerica ///////////////DIRECCION ENTIDAD REPRESENTADA
                                    isPhoneVersion={isPhoneVersion}
                                    titulo={datosEntidadRepresentada}
                                    ///////////////descripcionTipoViaDomicilio
                                    attributesTipoVia={{ ...objAttDireccion(datosEntidadRepresentada).descripcionTipoViaDomicilio, ...attributesValidation(tipoViaValidEntidad, objText.helperText.descripcionTipoViaDomicilioInteresado) }}
                                    tipoViaOptions={tipoVias}
                                    tipoViaGetOptionsLabel={(option) => option.descripcion}
                                    tipoViaOnChange={(e, newValue) => handleChange(e, newValue, objAttDireccion(datosEntidadRepresentada).descripcionTipoViaDomicilio.id)}
                                    tipoViaValue={values.tipoViaDomicilioEntidadRepresentada}
                                    refDescripcionTipoViaDomicilio={refTipoViaEntidad}
                                    ///////////////nombreDomicilio
                                    attributesNombreVia={{ ...objAttDireccion(datosEntidadRepresentada).nombreDomicilio, ...attributesValidation(nombreViaValidEntidad, objText.helperText.nombreDomicilioInteresado) }}
                                    nombreViaValue={values.nombreDomicilioEntidadRepresentada}
                                    nombreViaOnChange={handleChange}
                                    refNombreDomicilio={refNombreViaEntidad}
                                    nombreDomicilioInteresadoOnBlur={validationsOnBlur}
                                    ///////////////numeroDomicilio
                                    attributesNumero={{ ...objAttDireccion(datosEntidadRepresentada).numeroDomicilio, ...attributesValidation(numeroValidEntidad, objText.helperText.numeroDomicilioInteresado) }}
                                    numeroValue={values.numeroDomicilioEntidadRepresentada}
                                    numeroOnChange={handleChange}
                                    refNumeroDomicilio={refNumeroEntidad}
                                    numeroDomicilioInteresadoOnBlur={validationsOnBlur}
                                    ///////////////pisoDomicilio
                                    attributesPiso={{ ...objAttDireccion(datosEntidadRepresentada).pisoDomicilio, ...attributesValidation(pisoValidEntidad, objText.helperText.pisoDomicilioInteresado) }}
                                    pisoValue={values.pisoDomicilioEntidadRepresentada}
                                    pisoOnChange={handleChange}
                                    refPisoDomicilio={refPisoEntidad}
                                    numeroPisoInteresadoOnBlur={validationsOnBlur}
                                    ///////////////puertaDomicilio
                                    attributesPuerta={{ ...objAttDireccion(datosEntidadRepresentada).puertaDomicilio }}
                                    puertaValue={values.puertaDomicilioEntidadRepresentada}
                                    puertaOnChange={handleChange}
                                    ///////////////letraDomicilio
                                    attributesLetra={{ ...objAttDireccion(datosEntidadRepresentada).letraDomicilio }}
                                    letraValue={values.letraDomicilioEntidadRepresentada}
                                    letraOnChange={handleChange}
                                    ///////////////escaleraDomicilio
                                    attributesEscalera={{ ...objAttDireccion(datosEntidadRepresentada).escaleraDomicilio }}
                                    escaleraValue={values.escaleraDomicilioEntidadRepresentada}
                                    escaleraOnChange={handleChange}
                                    ///////////////nombreProvinciaDomicilio
                                    attributesProvincias={{ ...objAttDireccion(datosEntidadRepresentada).nombreProvinciaDomicilio, ...attributesValidation(provinciaValidEntidad, objText.helperText.nombreProvinciaDomicilioInteresado) }}
                                    provinciasOptions={provincias}
                                    provinciasGetOptionsLabel={(option) => option.descripcionCorta}
                                    provinciasOnChange={(e, newValue) => handleProvincia(e, newValue, objAttDireccion(datosEntidadRepresentada).nombreProvinciaDomicilio.id)}
                                    provinciasValue={values.provinciaDomicilioEntidadRepresentada}
                                    refProvinciaDomicilio={refProvinciaEntidad}
                                    ///////////////nombreMunicipioDomicilio
                                    attributesMunicipios={{ ...objAttDireccion(datosEntidadRepresentada).nombreMunicipioDomicilio, ...attributesValidation(municipioValidEntidad, objText.helperText.nombreMunicipioDomicilioInteresado) }}
                                    municipiosOptions={municipiosEntidad}
                                    municipiosGetOptionsLabel={(option) => option.descripcionCorta}
                                    municipiosOnChange={(e, newValue) => handleChange(e, newValue, objAttDireccion(datosEntidadRepresentada).nombreMunicipioDomicilio.id)}
                                    municipiosValue={values.municipioDomicilioEntidadRepresentada}
                                    refSelect={refMunicipioEntidad}
                                    refMunicipio={refMunicipioEntidad}
                                    ///////////////codigoPostalDomicilio
                                    attributesCodigoPostal={{ ...objAttDireccion(datosEntidadRepresentada).codigoPostalDomicilio, ...attributesValidation(codigoPostalValidEntidad, objText.helperText.codigoPostalDomicilioInteresado) }}
                                    codigoPostalValue={values.codigoPostalDomicilioEntidadRepresentada}
                                    codigoPostalOnChange={handleChange}
                                    refCodigoPostal={refCodigoPostalEntidad}
                                    codigoPostalOnBlur={validationsOnBlur}
                                    ///////////////nombrePaisDomicilio
                                    attributesPais={{ ...objAttDireccion(datosEntidadRepresentada).nombrePaisDomicilio }}
                                    paisesOptions={paises}
                                    paisesGetOptionLabel={(option) => option.descripcionCorta}
                                    paisesOnChange={(e, newValue) => handleChange(e, newValue, objAttDireccion(datosEntidadRepresentada).nombrePaisDomicilio.id)}
                                    paisesValue={values.paisDomicilioEntidadRepresentada}
                                />
                            </section>
                        </Grid>
                    }
                    <hr className={PageAltaUsuarioStyle().classLine} />
                    <TextoEstatico
                        estiloTexto={PageAltaUsuarioStyle().ClassProteccionDatos}
                        estiloGrid={PageAltaUsuarioStyle().classGridProteccionDatos}
                        {...objAttributes.proteccionDatos}
                        text={proteccionDatos}
                    />
                </form>
                <Grid container direction='row' spacing={2} justify={isPhoneVersion ? 'center' : 'flex-end'}
                    {...objAttributes.grids.botones} className={PageAltaUsuarioStyle().classGridButtons}
                >
                    <Grid item><button onClick={mostrarConfirmacionSalida} className={PageAltaUsuarioStyle().classButtonCancelar}{...objAttributes.btnCancelar}>{objText.botones.btnCancelar}</button></Grid>
                    <Grid item><button onClick={handleSubmit} className={PageAltaUsuarioStyle().classButton}{...objAttributes.btnCrearCuenta}>{textoBotonSubmit}</button></Grid>

                </Grid>
                <Backdrop className={PageAltaUsuarioStyle().classBackdrop} open={isLoading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Confirmacion handleChange={altaUsuarioMostrarConfirmacion} mostrar={mostrarConfirmacion} isPhoneVersion={isPhoneVersion}
                    titulo={objText.confirmacion.titulo}
                    mensaje={objText.confirmacion.mensaje}
                    botonera={componentsProperties.CONFIR_CANCELAR_ACEPTAR}
                    accionConfirmacion={redirigirCancelacion}
                    accionDenegacion={componentsProperties.CONFIR_SIN_ACCION}
                    tamMarginTop={propertiesApp.COMFIRMAR_MARGINTOP_10}
                    isPopUpPdf={false}
                    textBotonConfirmarPersonalizado={false}
                    isImagenPersonalizada={false}
                    centrarContenido={true}
                    isTextoEnriquecido={true}
                    />
                {alerts.map(m => (
                    <Snackbar open={message.msg} autoHideDuration={5000} onClose={() => setMessage({ severity: "", msg: "" })}>
                        <Alert
                            severity={message.severity}
                            variant="filled"
                        >
                            {message.msg}
                        </Alert>
                    </Snackbar>
                ))}
            </main>
        </ThemeProvider>
    )
}
